export const TYPES = {
    FETCHING_TRANSACTIONS_START: "FETCHING_TRANSACTIONS_START",
    FETCHING_TRANSACTIONS_SUCCESS: "FETCHING_TRANSACTIONS_SUCCESS",
    FETCHING_TRANSACTIONS_ERROR: "FETCHING_TRANSACTIONS_ERROR",
    ADDING_NEW_TRANSACTION_START: "ADDING_NEW_TRANSACTION_START",
    ADDING_NEW_TRANSACTION_SUCCESS: "ADDING_NEW_TRANSACTION_SUCCESS",
    ADDING_NEW_TRANSACTION_ERROR: "ADDING_NEW_TRANSACTION_ERROR",
};
